import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper } from 'lucide-react';

export const LatestArticleCard = ({ post }) => {
  if (!post) return null;
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid="hero-latest-article-card"
      className="group block relative overflow-hidden rounded-2xl border border-white/10 bg-slate-900/70 backdrop-blur-md hover:border-[#5cc1b0]/40 hover:bg-slate-900/80 transition-all shadow-xl"
    >
      {post.featured_image && (
        <div className="relative w-full h-32 sm:h-36 overflow-hidden">
          <img
            src={post.featured_image}
            alt={post.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            style={{ objectPosition: post.featured_image_position || 'center' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/30 to-transparent" />
        </div>
      )}
      <div className="p-4 sm:p-5">
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-semibold text-[#5cc1b0] mb-2">
          <Newspaper className="w-3 h-3" />
          Novo no blog
        </div>
        {post.category_name && (
          <span className="inline-block text-[10px] font-medium text-white/60 mb-1.5 uppercase tracking-wider">
            {post.category_name}
          </span>
        )}
        <h3 className="font-heading text-sm sm:text-base font-semibold text-white leading-snug line-clamp-3 mb-2 group-hover:text-[#5cc1b0] transition-colors">
          {post.title}
        </h3>
        <div className="inline-flex items-center gap-1 text-xs font-medium text-white/70 group-hover:text-[#5cc1b0] transition-colors">
          Ler artigo
          <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" />
        </div>
      </div>
    </Link>
  );
};
